const AppHeader = () => {
  return (
    <header
      style={{
        backgroundColor: "#1f1f1d", // full-width background
        padding: "20px 0",
      }}
    >
      <div
        style={{
          maxWidth: "1080px",
          margin: "0 auto",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Logo */}
        <a href="https://www.nepprepbasketball.com">
          <img
            src="https://storage.mobilebuilder.net/users/images/d3b81a5d-9ecf-4a97-81e0-b5f47ea5f318.png" // 🔁 replace with your actual logo path or URL
            alt="NEP Prep Basketball"
            style={{ maxWidth: "100%", height: "auto", maxHeight: "100px" }}
          />
        </a>

        {/* Navigation */}
        {/* <nav style={{
          display: "flex",
          gap: "30px",
          alignItems: "center",
          color: "#ffffff",
          textDecoration: "none",
          fontSize: "20px",
          fontWeight: "500",
          fontFamily: 'Calibri, Candara, Segoe, "Segoe UI", sans-serif'
        }}>
          <a href="#about" style={navLinkStyle}>About</a>
          <a href="#events" style={navLinkStyle}>Teams Schedule and Events</a>
          <a href="#contact" style={navLinkStyle}>Contact</a>
        </nav> */}
      </div>
    </header>
  );
};

const navLinkStyle = {
  color: "#ffffff",
  textDecoration: "none",
  fontSize: "16px",
  fontWeight: "500",
};

export default AppHeader;
